(function() {
  var Controller, string_utils,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  string_utils = App.load('core::utils/string');

  exports.StepsController = (function(superClass) {
    extend(StepsController, superClass);

    function StepsController(scope, transitions, service, state, modal, http, window, timeout) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.state = state;
      this.modal = modal;
      this.http = http;
      this.window = window;
      this.timeout = timeout;
      this.numSteps = bind(this.numSteps, this);
      this.isOnLastStep = bind(this.isOnLastStep, this);
      this.isOnFirstStep = bind(this.isOnFirstStep, this);
      this.saveSurvey = bind(this.saveSurvey, this);
      this.gotoNextStep = bind(this.gotoNextStep, this);
      this.gotoPrevStep = bind(this.gotoPrevStep, this);
      StepsController.__super__.constructor.apply(this, arguments);
      this.scope.fullpage = true;
      this.scope.saved = false;
      this.service.configLoaded.then((function(_this) {
        return function() {
          if (_.isEmpty(_this.service.survey) && _this.state.params.id && _this.state.params.step) {
            return _this.http.get("api/nitrogen-surveys/" + _this.state.params.id).then(function(response) {
              _this.service.year = response.data.year;
              _this.service.crop = response.data.crop.name;
              _this.service.survey = response.data;
              return _this.service.gotoStep(_this.state.params.step - 1, _this.state.params.id, false);
            })["catch"](function(error) {
              return _this.state.go('fields');
            });
          }
        };
      })(this));
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          if (!_this.service.triggerBrowserWarning) {
            return;
          }
          if (string_utils.startsWith($transition.to().name, _this.state.current.name)) {
            return;
          }
          if (!_this.service.surveyComplete()) {
            if (!_this.window.confirm('You have not completed the N Solver survey. You will not receive VariMax maps for fields with incomplete data.\n\nAre you sure you wish to leave?')) {
              return false;
            }
          }
          return _this.service.save(_this.service.stateParams.id);
        };
      })(this));
      this.window.onbeforeunload = (function(_this) {
        return function() {
          _this.service.save(_this.service.stateParams.id);
          if (!_this.service.surveyComplete()) {
            return 'You have unsaved changes.';
          }
          return null;
        };
      })(this);
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          _this.transitionStart();
          return _this.window.onbeforeunload = null;
        };
      })(this));
    }

    StepsController.prototype.gotoPrevStep = function() {
      return this.service.gotoStep(this.service.currentStepIndex - 1);
    };

    StepsController.prototype.gotoNextStep = function() {
      this.service.nextAttempted = true;
      if (!this.service.stepComplete(this.service.currentStepName)) {
        return;
      }
      return this.service.gotoStep(this.service.currentStepIndex + 1);
    };

    StepsController.prototype.saveSurvey = function() {
      this.service.nextAttempted = true;
      if (!this.service.stepComplete(this.service.currentStepName)) {
        return;
      }
      return this.service.save(this.service.stateParams.id).then((function(_this) {
        return function() {
          _this.scope.saved = true;
          return _this.timeout(function() {
            return _this.state.go('grower.nsolver', {}, {
              reload: 'grower.nsolver'
            });
          }, 2000);
        };
      })(this));
    };

    StepsController.prototype.isOnFirstStep = function() {
      return this.service.currentStepIndex === 0;
    };

    StepsController.prototype.isOnLastStep = function() {
      var ref;
      if (((ref = this.service.config) != null ? ref.steps : void 0) == null) {
        return false;
      }
      return this.service.currentStepIndex === Object.keys(this.service.config.steps).length - 1;
    };

    StepsController.prototype.numSteps = function() {
      if (this.service.config.steps == null) {
        return 0;
      }
      return Object.keys(this.service.config.steps).length;
    };

    return StepsController;

  })(Controller);

}).call(this);
